import { render, staticRenderFns } from "./SignalingServers.vue?vue&type=template&id=28f4924e&scoped=true"
import script from "./SignalingServers.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignalingServers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignalingServers.vue?vue&type=style&index=0&id=28f4924e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4924e",
  null
  
)

export default component.exports